// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Mint from 'mint-ui'
import router from './router'
// import axios from 'axios'
import axios from './util/http'
import { MessageBox } from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint)

Vue.config.productionTip = false

Vue.prototype.$axios = axios
Vue.$messagebox = Vue.prototype.$messagebox = MessageBox;  
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js